module.exports = __webpack_public_path__ + "static/media/undraw_searching_p5ux.2beb1e7f.svg";